<script lang="ts">
    import type { Snippet } from "svelte";


    let {
        loaded = false,
        class: Classname = "", // Renames the 'class' prop to 'Classname'
        style = "",
        children
    }: {
        loaded: boolean;
        "class"?: string;  // Use quotes here because 'class' is a reserved word
        style?: string;
        children?: Snippet;
    } = $props();
</script>

{#if loaded}
    {@render children?.()}
{:else}
    <i class="spinner-border text-primary {Classname}" style="{style}" role="status"></i>
{/if}
